import moment from 'moment';

export const DefaultTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const isCurrentlyLate = (standardTime?: string): boolean => {
    if (!standardTime) return true;
    try {
        const curr = new Date();
        const time = new Date(standardTime);
        return time.getTime() < curr.getTime();
    } catch (error) {
        return true;
    }
};

export const getDefaultEvalDate = (currTime: string): string => {
    const now = new Date(currTime);
    const m = now.getMinutes();
    const addM = (5 - (m % 5)) % 5;
    return moment(now).add(addM, 'minutes').format(DefaultTimeFormat);
};
